module.exports = __webpack_public_path__ + "img/hourglass.9806f43b.png";